import { colors } from 'assets/styled/tokens';
import styled from 'styled-components';

export const StyledApplicationTableExecutedByProviderCell = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 14px;
`;
export const StyledApplicationType = styled.span`
  font-weight: 400;
  color: ${colors.gray};
`;
